import {cashPriceObject} from "../cashPriceObject";

export class cashPriceObjectSUB extends cashPriceObject {
    // eslint-disable-next-line
    constructor() {
        super();
    }

    getCashPrice = (params) => {
        const {
            vehiclePrice,
            setVat,
            vatValue,
            BPM
        } = params;

        return !setVat ? vehiclePrice : BPM !== null ? Math.ceil(+Number((Math.round(((vehiclePrice - BPM) / vatValue) + "e" + 0)  + "e-" + 0))) + BPM : Math.ceil(+Number((Math.round((vehiclePrice / vatValue) + "e" + 0)  + "e-" + 0)));
    }

    getTotalInstallmentRound = (params) => {
        const {
            totalInstallment
        } = params;

        return Math.trunc(totalInstallment);
    }

}

export default cashPriceObjectSUB;